export enum BenefitClaimant {
    BENEFICIARY = 'The benefits are being claimed by me / the beneficiary.',
    LEGAL_GUARDIAN = 'The benefits are being claimed by the legal guardian of a minor/incompetent person\'s estate.',
    TRUSTEE = 'The benefits are being claimed by a trustee of a trust or a personal representative of an estate.'
}
